import React from "react";
import styles from "./PrivacyPolicy.module.css";

export default function TermsOfService() {
  return (
    <div className={styles.privacyRoot}>
      <div className={styles.privacyContainer}>
        <h1 className={styles.privacyTitle}>Regulamin świadczenia usług – Paperly</h1>

        <p>
          Niniejszy Regulamin określa zasady świadczenia usług drogą elektroniczną w ramach serwisu
          internetowego Paperly dostępnego pod adresem paperly.pl ("Serwis") oraz w aplikacji webowej
          Paperly ("Aplikacja"). Akceptacja Regulaminu jest równoznaczna z zawarciem umowy o świadczenie
          usług drogą elektroniczną z Administratorem.
        </p>

        <h2>1. Definicje</h2>
        <ul>
          <li><b>Administrator</b> – Codellio Bartosz Skrzypek, NIP: 8172154584, e‑mail: kontakt@paperly.pl.</li>
          <li><b>Użytkownik</b> – osoba fizyczna, prawna lub jednostka organizacyjna korzystająca z Serwisu.</li>
          <li><b>Konto</b> – przydzielona Użytkownikowi przestrzeń w Aplikacji po rejestracji i logowaniu.</li>
          <li><b>Usługi</b> – funkcjonalności świadczone w Serwisie, w tym generowanie/automatyzacja dokumentów i zarządzanie plikami.</li>
          <li><b>Regulamin</b> – niniejszy dokument.</li>
        </ul>

        <h2>2. Postanowienia ogólne</h2>
        <ul>
          <li>Warunkiem korzystania z Usług jest akceptacja Regulaminu i posiadanie aktywnego Konta.</li>
          <li>Administrator świadczy Usługi zgodnie z Regulaminem i powszechnie obowiązującymi przepisami prawa.</li>
          <li>Informacje o funkcjach Serwisu mogą być prezentowane w interfejsie Aplikacji oraz w materiałach informacyjnych.</li>
        </ul>

        <h2>3. Rejestracja i Konto</h2>
        <ul>
          <li>Rejestracja wymaga podania prawdziwych danych oraz ustanowienia hasła; Użytkownik odpowiada za ich poprawność.</li>
          <li>Użytkownik jest zobowiązany do zachowania poufności danych logowania i ponosi odpowiedzialność za działania w Koncie.</li>
          <li>Administrator może czasowo zablokować lub usunąć Konto w przypadku naruszeń prawa lub Regulaminu.</li>
        </ul>

        <h2>4. Zakres i warunki świadczenia Usług</h2>
        <ul>
          <li>Zakres Usług obejmuje m.in. przesyłanie, przetwarzanie i generowanie dokumentów oraz integracje wskazane w Aplikacji.</li>
          <li>Usługi mogą wymagać akceptacji dodatkowych warunków (np. polityka integracji z usługami zewnętrznymi).</li>
          <li>Administrator może wprowadzać zmiany techniczne i funkcjonalne, nie pogarszając istotnie wartości Usług dla Użytkownika.</li>
        </ul>

        <h2>5. Zasady dopuszczalnego korzystania</h2>
        <ul>
          <li>Zakazane jest dostarczanie treści bezprawnych i naruszanie praw osób trzecich.</li>
          <li>Zakazane jest podejmowanie działań zmierzających do zakłócenia działania Serwisu lub obchodzenia zabezpieczeń.</li>
          <li>Użytkownik zobowiązuje się do korzystania z Serwisu zgodnie z jego przeznaczeniem i Regulaminem.</li>
        </ul>

        <h2>6. Płatności i rozliczenia</h2>
        <ul>
          <li>Wybrane Usługi mogą być odpłatne zgodnie z cennikiem przedstawionym w Serwisie lub w ofercie indywidualnej.</li>
          <li>Płatności realizowane są za pośrednictwem operatorów płatności lub na podstawie faktur – zgodnie z ich regulaminami.</li>
          <li>Zmiany cen nie wpływają na trwający okres rozliczeniowy, o ile nie wskazano inaczej w ofercie.</li>
        </ul>

        <h2>7. Własność intelektualna</h2>
        <ul>
          <li>Prawa do Serwisu i Aplikacji, w tym do elementów graficznych, oprogramowania i treści, przysługują Administratorowi lub licencjodawcom.</li>
          <li>Użytkownik zachowuje prawa do własnych danych i dokumentów wprowadzonych do Serwisu.</li>
          <li>Niedozwolone jest kopiowanie, modyfikowanie i rozpowszechnianie Serwisu poza przypadkami dopuszczonymi prawem.</li>
        </ul>

        <h2>8. Odpowiedzialność</h2>
        <ul>
          <li>Administrator nie ponosi odpowiedzialności za skutki wykorzystania Serwisu niezgodnie z Regulaminem lub przeznaczeniem.</li>
          <li>Administrator nie odpowiada za treści i dane wprowadzane przez Użytkownika.</li>
          <li>W najszerszym dopuszczalnym przez prawo zakresie odpowiedzialność Administratora jest ograniczona do rzeczywiście poniesionej szkody.</li>
        </ul>

        <h2>9. Dane osobowe i prywatność</h2>
        <p>
          Zasady przetwarzania danych osobowych określa Polityka Prywatności dostępna w Serwisie. Korzystanie z Usług
          wymaga zapoznania się z Polityką Prywatności; zgody marketingowe są dobrowolne i mogą być wycofane w każdym czasie.
        </p>

        <h2>10. Czas trwania umowy i rozwiązanie</h2>
        <ul>
          <li>Umowa o świadczenie Usług zostaje zawarta na czas nieokreślony z chwilą akceptacji Regulaminu.</li>
          <li>Użytkownik może rozwiązać umowę w każdym czasie poprzez usunięcie Konta lub zakończenie subskrypcji.</li>
          <li>Administrator może wypowiedzieć umowę z ważnych przyczyn (np. rażące naruszenie Regulaminu) z zachowaniem odpowiedniego terminu lub ze skutkiem natychmiastowym, jeśli wymagają tego przepisy prawa.</li>
        </ul>

        <h2>11. Reklamacje</h2>
        <ul>
          <li>Reklamacje dotyczące działania Serwisu można składać na adres e‑mail: kontakt@paperly.pl.</li>
          <li>W zgłoszeniu prosimy opisać problem, podać dane identyfikujące Konto oraz dane kontaktowe.</li>
          <li>Reklamacje rozpatrywane są niezwłocznie, nie później niż w terminie 30 dni.</li>
        </ul>

        <h2>12. Zmiany Regulaminu</h2>
        <ul>
          <li>Administrator może zmienić Regulamin z ważnych przyczyn, w szczególności zmian funkcjonalnych, prawnych lub organizacyjnych.</li>
          <li>O zmianie Regulaminu Użytkownicy zostaną poinformowani poprzez publikację nowej treści w Serwisie; zmiany obowiązują od daty wskazanej w informacji.</li>
        </ul>

        <h2>13. Prawo właściwe i jurysdykcja</h2>
        <ul>
          <li>Do Regulaminu stosuje się prawo polskie.</li>
          <li>W sprawach nieuregulowanych mają zastosowanie właściwe przepisy prawa powszechnie obowiązującego.</li>
        </ul>

        <h2>14. Kontakt</h2>
        <p>
          Administrator: Codellio Bartosz Skrzypek, NIP: 8172154584, e‑mail: <a href="mailto:kontakt@paperly.pl">kontakt@paperly.pl</a>.
        </p>
      </div>
    </div>
  );
} 